(function () {
  // Im Theme-Editor/Preview keine harten Reloads oder Trail-Persistenz
  var isDesignMode = !!(window.Shopify && Shopify.designMode);
  var isPreview    = /[?&]preview_theme_id=/.test(location.search);

  // ---- Utilities ----
  function normPath(input){
    try {
      var u = new URL(input, location.origin);
      var p = u.pathname.replace(/\/+$/,'');
      return p === '' ? '/' : p;
    } catch(e){
      var p = String(input||'').replace(/\?.*$/,'').replace(/\/+$/,'');
      return p === '' ? '/' : p;
    }
  }
  function rootPath(rootUrl){
    try { return normPath(new URL(rootUrl, location.origin).pathname); }
    catch(_) { return '/'; }
  }
  function getTrail(){ try { return JSON.parse(sessionStorage.getItem('HL_TRAIL')||'[]'); } catch(e){ return []; } }
  function setTrail(arr){ try { sessionStorage.setItem('HL_TRAIL', JSON.stringify(arr)); } catch(e){} }

  function renderTrail(trail){
    var nav  = document.querySelector('.breadcrumb-nav');
    var list = document.querySelector('.breadcrumb-nav .breadcrumb-list');
    if (!nav || !list || !trail || !trail.length) return;

    var sepNode = document.querySelector('.breadcrumb-nav .breadcrumb-list_separator');
    var sepHTML = sepNode ? sepNode.innerHTML : '/';

    var prevVis = nav.style.visibility;
    nav.style.visibility = 'hidden';
    list.innerHTML = '';

    trail.forEach(function(step, idx){
      var li = document.createElement('li');
      li.className = 'breadcrumb-list_item';

      if (idx < trail.length - 1){
        var a = document.createElement('a');
        a.className = 'breadcrumb-list_link';

        var href = step.url;
        if (!isDesignMode && !isPreview) {
          href += (href.indexOf('?') >= 0 ? '&' : '?') + 'hlnav=' + Date.now(); // Cachebuster nur live
        }
        a.href = href;
        a.textContent = step.title;
        a.setAttribute('rel','external');
        a.setAttribute('data-hl-hard','1');
        a.setAttribute('data-no-instant','true');
        a.setAttribute('data-turbo','false');
        a.setAttribute('data-turbolinks','false');
        a.setAttribute('data-barba-prevent','self');
        a.setAttribute('data-swup-prevent','true');
        a.setAttribute('data-ajax','false');
        li.appendChild(a);
      } else {
        var span = document.createElement('span');
        span.className = 'breadcrumb-list_link';
        span.setAttribute('aria-current', 'page');
        span.textContent = step.title;
        li.appendChild(span);
      }

      if (idx < trail.length - 1){
        var iEl = document.createElement('i');
        iEl.className = 'breadcrumb-list_separator';
        iEl.innerHTML = sepHTML;
        li.appendChild(iEl);
      }

      list.appendChild(li);
    });

    nav.style.visibility = prevVis || '';
  }

  function updateTrail(ROOT_URL, TMPL, INITIAL_TITLE){
    // URL clean-up, falls von Cachebuster zurück
    try {
      if (location.search.indexOf('hlnav=') >= 0) {
        history.replaceState(null, '', location.pathname);
      }
    } catch(_) {}

    var trail = getTrail();
    var rootP = rootPath(ROOT_URL);

    var atHome = (TMPL === 'index') || (normPath(location.pathname) === rootP);
    if (atHome){
      var startTitle = (document.querySelector('.breadcrumb-nav .breadcrumb-list a')?.textContent || 'Startseite').trim();
      trail = [{ title: startTitle, url: rootP }];
      setTrail(trail);
      renderTrail(trail);
      return;
    }

    // Home vorne sicherstellen
    if (!trail.length || normPath(trail[0].url) !== rootP){
      trail = [{ title: 'Startseite', url: rootP }];
    } else {
      trail[0].title = (document.querySelector('.breadcrumb-nav .breadcrumb-list a')?.textContent || trail[0].title || 'Startseite').trim();
      trail[0].url   = rootP;
    }

    // Aktuelle Seite bestimmen
    var path  = normPath(location.pathname) + (location.search || '');
    var title = INITIAL_TITLE || document.title || path;
    var cur   = { title: title, url: path };

    // Einfügen / Kürzen bis zum Ziel
    var idx = trail.findIndex(function(t){ return normPath(t.url) === normPath(cur.url); });
    if (idx >= 0){
      trail = trail.slice(0, idx + 1);
      trail[trail.length - 1] = cur;
    } else {
      trail.push(cur);
    }

    // Doppelte nacheinander entfernen
    var dedup = [trail[0]];
    for (var j=1;j<trail.length;j++){
      if (normPath(trail[j].url) !== normPath(dedup[dedup.length-1].url)) dedup.push(trail[j]);
    }

    // Maximale Länge
    var MAX_STEPS = 3;
    if (dedup.length > MAX_STEPS) dedup = dedup.slice(dedup.length - MAX_STEPS);

    setTrail(dedup);
    renderTrail(dedup);
  }

  // Harte Navigation nur live (nicht im Editor/Preview)
  document.addEventListener('click', function(ev){
    if (isDesignMode || isPreview) return;
    var a = ev.target && ev.target.closest('.breadcrumb-nav .breadcrumb-list a[data-hl-hard="1"]');
    if (!a) return;
    if (ev.defaultPrevented || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || a.target === '_blank') return;

    ev.preventDefault();
    try {
      var href  = a.getAttribute('href');
      var trail = getTrail();
      var idx   = trail.findIndex(function(t){ return normPath(t.url) === normPath(href); });
      if (idx >= 0) setTrail(trail.slice(0, idx + 1));
    } catch(_) {}

    try { window.location.assign(a.href); } catch(_) { window.location.href = a.getAttribute('href'); }
  }, { capture: true });

  // bfcache-Fix nur live (Editor neigt zu Loops)
  window.addEventListener('pageshow', function(e){
    if (isDesignMode || isPreview) return;
    if (e.persisted) { try { location.reload(); } catch(_) {} }
  });

  // Bootstrap vom Mount-Element
  function boot(){
    var mount = document.getElementById('hl-trail-mount');
    if (!mount) return;
    var ROOT_URL = mount.getAttribute('data-root-url') || '/';
    var TMPL     = mount.getAttribute('data-template') || '';
    var TITLE    = mount.getAttribute('data-title') || '';
    updateTrail(ROOT_URL, TMPL, TITLE);

    // Falls Breadcrumb später injected wird
    var tries = 0, iv = setInterval(function(){
      tries++;
      if (document.querySelector('.breadcrumb-nav .breadcrumb-list')){
        clearInterval(iv);
        renderTrail(getTrail());
      } else if (tries > 40){
        clearInterval(iv);
      }
    }, 100);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
